<template>
  <div :class="['report-table-wrapper', wrapperClass]">
    <table :class="tableClass">
      <thead v-if="$slots.header">
        <slot name="header" />
      </thead>

      <tbody v-if="!isMobile && loading && hasItems">
        <template v-for="(item, index) in items" :key="itemKeyValue(item, index)">
          <slot name="row" :item="item" :index="index" />
        </template>
      </tbody>

      <tbody v-else-if="isMobile && loading && hasItems">
        <template v-if="$slots.mobile">
          <template v-for="(item, index) in items" :key="itemKeyValue(item, index)">
            <slot name="mobile" :item="item" :index="index" />
          </template>
        </template>
        <template v-else>
          <template v-for="(item, index) in items" :key="itemKeyValue(item, index)">
            <slot name="row" :item="item" :index="index" />
          </template>
        </template>
      </tbody>

      <tbody v-else-if="loading">
        <tr>
          <td :colspan="emptyColspan" style="text-align: center">
            <span class="noTickets">{{ translatedEmptyMessage }}</span>
          </td>
        </tr>
      </tbody>
    </table>

    <slot name="loader">
      <MyLoading :viewLoader="loading" type="" />
    </slot>
  </div>
</template>

<script>
import MyLoading from "@/components/MyLoading.vue";

export default {
  name: "ReportTable",
  components: {
    MyLoading,
  },
  props: {
    items: {
      type: Array,
      default: () => [],
    },
    loading: {
      type: Boolean,
      default: false,
    },
    emptyColspan: {
      type: Number,
      default: 1,
    },
    emptyMessage: {
      type: String,
      default: "reports.noResult",
    },
    tableClass: {
      type: [String, Array, Object],
      default: () => [],
    },
    wrapperClass: {
      type: [String, Array, Object],
      default: () => [],
    },
    rowKey: {
      type: Function,
      default: null,
    },
  },
  computed: {
    isMobile() {
      return this.$IsMobile();
    },
    hasItems() {
      return Array.isArray(this.items) && this.items.length > 0;
    },
    translatedEmptyMessage() {
      if (!this.emptyMessage) {
        return "";
      }

      try {
        return this.$t(this.emptyMessage);
      } catch (error) {
        return this.emptyMessage;
      }
    },
  },
  methods: {
    itemKeyValue(item, index) {
      if (this.rowKey) {
        try {
          const customKey = this.rowKey(item, index);
          if (customKey !== undefined && customKey !== null) {
            return customKey;
          }
        } catch (error) {
          // fall back to default key generation
        }
      }

      if (item && typeof item === "object") {
        const candidates = [
          "id",
          "ticketNumber",
          "ticket_esteso",
          "ticket_url",
          "name",
          "data",
          "data_charge",
          "url",
        ];

        for (const key of candidates) {
          if (Object.prototype.hasOwnProperty.call(item, key)) {
            const value = item[key];
            if (value !== undefined && value !== null && value !== "") {
              return `${key}-${value}`;
            }
          }
        }
      }

      return `row-${index}`;
    },
  },
};
</script>

<style scoped>
.report-table-wrapper {
  width: 100%;
}
</style>
